
import Vue from "vue";
import { v4 } from "uuid";
import { IDataTableColumn } from "winfakt-vue-components";
import { printLocalDateTime } from "@/utils/pretty-print";
import { DeletedPurchase } from "@/models/base/deleted-purchase";
import { DeletedPurchasesService } from "@/services/deleted-purchases-service";

export default Vue.extend({
	data(){
		return {
			records: -1,
			data: [] as DeletedPurchase[],
			limit: 500,
			orderColumn: "this.ID",
			orderAscending: false,
			fetchId: "",
			selectedItems: [] as DeletedPurchase[],
			openedItem: null as null | DeletedPurchase
		};
	},
	computed: {
		columns():IDataTableColumn[] {
			return [
				{
					name: "Aankoop ID",
					property: "PurchaseID",
					width: "80px"
				},
				{
					name: "Nummer",
					property: "ComputedFriendlyID",
					width: "120px"
				},
				{
					name: "Contact ID",
					property: "ContactID",
					width: "80px"
				},
				{
					name: "Datum verwijderd",
					property: "DeletedDate",
					width: "200px",
					print: printLocalDateTime
				},
				{
					name: "Verwijderd door gebruiker ID",
					property: "DeletedByUserID",
					width: "200px"
				}
			];
		}
	},
	watch: {
		selectedItems: {
			deep: true,
			handler(){
				if (this.selectedItems.length == 0) return;
				this.openedItem = this.selectedItems[0];
				this.selectedItems.splice(0, this.selectedItems.length);
			}
		}
	},
	methods: {
		async fetch(){
			if (this.records != -1) {
				if (this.data.length >= this.records) return;
			}
			if (this.fetchId) return;
			let fetchId = v4();
			this.fetchId = fetchId;
			try{
				let result = await DeletedPurchasesService.getDeletedPurchases(this.limit, this.data.length, this.orderColumn, this.orderAscending ? "ASC" : "DESC");
				if (fetchId != this.fetchId) return;
				this.records = result.records;
				this.data = result.data;
			}catch(err){

			}
			this.fetchId = "";
		},
		setOrderColumn(column:string, orderAscending:boolean){
			this.data = [];
			this.orderColumn = column;
			this.orderAscending = orderAscending;
			this.records = -1;
			this.fetchId = "";
			this.fetch();
		},
		close(){
			this.$emit("close");
		},
		onItemClick(item:DeletedPurchase){
			this.openedItem = item;
		},
		onScroll(event:Event) {
			let table = event.target as HTMLElement;
			let lastChild = table.lastChild as HTMLElement;
			if (!lastChild) {
				return;
			}

			let tableRect = table.getBoundingClientRect();
			let childRect = lastChild.getBoundingClientRect();

			let tableBottomY = tableRect.top + tableRect.height;
			if (childRect.top < (tableBottomY + 2000)) {
				this.fetch();
			}
		},
		async restoreOpenedItem(){
			if (!this.openedItem) return;
			let item = this.openedItem;
			this.$router.push(`/purchase/new?fromJson=${item.RawJson}`);
			this.close();
		}
	},
	mounted(){
		this.fetch();
	}
});
